import store from '@/store'

const createGlobalSuccessNotification = notification => {
  store.dispatch('setNotification', notification)

  setTimeout(() => {
    store.dispatch('clearNotification')
  }, 5000)
}

const createGlobalSuccessQuickNotification = message => {
  createGlobalSuccessNotification({
    notification: {
      type: 'success',
      content: message
    }
  })
}

const createInfoNotification = notification => {
  store.dispatch('setNotification', notification)
}

export default {
  createGlobalSuccessNotification,
  createGlobalSuccessQuickNotification,
  createInfoNotification
}
